import dayjs from "dayjs";
import { IResult, RewardsAccount } from "redmond";

/**
 * @deprecated Use getEarnTag from the common module instead.
 * This function returns a string with HTML markup which is not safe.
 * The getEarnTag function provides a safer alternative using JSX.
 */
export const getEarnTagText = (
  rewardsAccount: RewardsAccount,
  currency: string,
  uiVariant: "hotels" | "cars" | "flights" | "packages"
) => {
  const earnRateMap = {
    hotels: rewardsAccount.earn.hotelsMultiplier,
    cars: rewardsAccount.earn.carsMultiplier,
    flights: rewardsAccount.earn.flightsMultiplier,
    packages: rewardsAccount.earn.flightsMultiplier, // Packages use flights multiplier
  };
  const earnRate = earnRateMap[uiVariant];
  const multiplier = currency.includes("cash") ? "%" : "X";
  if (earnRate && uiVariant !== "packages") {
    return `Earn <span class="font-bold">${earnRate}${multiplier} ${currency}</span> on ${uiVariant}`;
  } else if (earnRate && uiVariant === "packages") {
    return `Earn <span class="font-bold">${earnRateMap["hotels"]}${multiplier} ${currency}</span> on hotels, <span class="font-bold">${earnRateMap["flights"]}${multiplier} ${currency}</span> on flights`;
  }

  return undefined;
};

export const getCrossSellEarnText = (rewardsAcct?: RewardsAccount) => {
  if (!rewardsAcct) return "";
  const currency =
    rewardsAcct.rewardsBalance.currency ??
    rewardsAcct.rewardsBalance.currencyDescription;
  const multiplier = currency.toLowerCase().includes("cash") ? "%" : "X";

  return `Earn ${
    rewardsAcct.earn.hotelsMultiplier
  }${multiplier} ${currency.toLowerCase()} with your ${
    rewardsAcct.productDisplayName
  } account.`;
};

export const getBannerText = (
  location: IResult | null,
  fromDate: Date,
  untilDate: Date,
  rewardsAcct: RewardsAccount,
  isMobile?: boolean,
  shortEarnText?: boolean
) => {
  if (!rewardsAcct) {
    return "";
  }
  const currency =
    rewardsAcct.rewardsBalance.currency ??
    rewardsAcct.rewardsBalance.currencyDescription;
  const multiplier = currency.toLowerCase().includes("cash") ? "%" : "X";

  const [city, state] = location?.label ? location.label.split(",") : [];

  if (isMobile) {
    return `Choose from a variety of hotels in <br> <strong>${city}, ${state}</strong> from <strong>${dayjs(
      fromDate
    ).format("MMM, D")} - ${dayjs(untilDate).format("MMM, D")}</strong>`;
  } else if (shortEarnText) {
    return `Choose from a variety of hotels in <strong>${city}, ${state}</strong> from <strong>${dayjs(
      fromDate
    ).format("MMM, D")} - ${dayjs(untilDate).format(
      "MMM, D"
    )}</strong> <span class="hotel-cross-sell-banner-rewards-text">
      Earn ${
        rewardsAcct.earn.hotelsMultiplier
      }${multiplier} ${currency.toLowerCase()} with your ${
      rewardsAcct.productDisplayName
    }
      account.</span>`;
  } else {
    return `Choose from a variety of hotels in <strong>${city}, ${state}</strong> from <strong>${dayjs(
      fromDate
    ).format("MMM, D")} - ${dayjs(untilDate).format(
      "MMM, D"
    )}</strong><span class="hotel-cross-sell-banner-rewards-text">Book with flexibility and earn ${
      rewardsAcct.earn.hotelsMultiplier
    }${multiplier} ${currency.toLowerCase()} with your ${
      rewardsAcct.productDisplayName
    } account.</span>`;
  }
};

export const getEarnBannerText = (
  earnRate: string | number,
  currency: string,
  productName: string
) => {
  const multiplier = currency.toLowerCase().includes("cash") ? "%" : "X";
  return `Earn <span class="font-bold">${earnRate}${multiplier} ${currency}</span> with your ${productName} account`;
};

export const getViewButtonText = (
  locationName: string,
  isInBanner?: boolean
) => {
  if (isInBanner) {
    return `View all hotels in ${locationName}`;
  }
  return `View more hotels in ${locationName}`;
};
